module.exports = __webpack_public_path__ + "img/GlobalRenaqua.85ee179e.png";